import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _provider, _providerCalled;
// src/timeoutManager.ts
var defaultTimeoutProvider = {
  // We need the wrapper function syntax below instead of direct references to
  // global setTimeout etc.
  //
  // BAD: `setTimeout: setTimeout`
  // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
  //
  // If we use direct references here, then anything that wants to spy on or
  // replace the global setTimeout (like tests) won't work since we'll already
  // have a hard reference to the original implementation at the time when this
  // file was imported.
  setTimeout: (callback, delay) => setTimeout(callback, delay),
  clearTimeout: timeoutId => clearTimeout(timeoutId),
  setInterval: (callback, delay) => setInterval(callback, delay),
  clearInterval: intervalId => clearInterval(intervalId)
};
var TimeoutManager = (_provider = /*#__PURE__*/_classPrivateFieldLooseKey("provider"), _providerCalled = /*#__PURE__*/_classPrivateFieldLooseKey("providerCalled"), class TimeoutManager {
  constructor() {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    Object.defineProperty(this, _provider, {
      writable: true,
      value: defaultTimeoutProvider
    });
    Object.defineProperty(this, _providerCalled, {
      writable: true,
      value: false
    });
  }
  setTimeoutProvider(provider) {
    if (process.env.NODE_ENV !== "production") {
      if (_classPrivateFieldLooseBase(this, _providerCalled)[_providerCalled] && provider !== _classPrivateFieldLooseBase(this, _provider)[_provider]) {
        console.error("[timeoutManager]: Switching provider after calls to previous provider might result in unexpected behavior.", {
          previous: _classPrivateFieldLooseBase(this, _provider)[_provider],
          provider
        });
      }
    }
    _classPrivateFieldLooseBase(this, _provider)[_provider] = provider;
    if (process.env.NODE_ENV !== "production") {
      _classPrivateFieldLooseBase(this, _providerCalled)[_providerCalled] = false;
    }
  }
  setTimeout(callback, delay) {
    if (process.env.NODE_ENV !== "production") {
      _classPrivateFieldLooseBase(this, _providerCalled)[_providerCalled] = true;
    }
    return _classPrivateFieldLooseBase(this, _provider)[_provider].setTimeout(callback, delay);
  }
  clearTimeout(timeoutId) {
    _classPrivateFieldLooseBase(this, _provider)[_provider].clearTimeout(timeoutId);
  }
  setInterval(callback, delay) {
    if (process.env.NODE_ENV !== "production") {
      _classPrivateFieldLooseBase(this, _providerCalled)[_providerCalled] = true;
    }
    return _classPrivateFieldLooseBase(this, _provider)[_provider].setInterval(callback, delay);
  }
  clearInterval(intervalId) {
    _classPrivateFieldLooseBase(this, _provider)[_provider].clearInterval(intervalId);
  }
});
var timeoutManager = new TimeoutManager();
function systemSetTimeoutZero(callback) {
  setTimeout(callback, 0);
}
export { TimeoutManager, defaultTimeoutProvider, systemSetTimeoutZero, timeoutManager };